import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';

interface LineItemSortMenuClickEvent {
  key: string;
  domEvent: { stopPropagation: () => void };
}

export function handleLineItemSortMenuClick(
  event: LineItemSortMenuClickEvent,
  onSortChange: (key: string) => void,
): void {
  event.domEvent.stopPropagation();
  onSortChange(event.key);
}

export function getLineItemAccordionTriggerProps(isOpen: boolean) {
  return {
    role: 'button' as const,
    tabIndex: 0,
    'aria-expanded': isOpen,
    onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.target !== event.currentTarget) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.currentTarget.click();
      }
    },
  };
}

export function LineItemAccordionToggleButton({ isOpen }: { isOpen: boolean }) {
  return (
    <motion.div
      animate={{ rotate: isOpen ? 180 : 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      className="line-item-accordion-toggle flex size-6 items-center justify-center rounded-md text-slate-500 transition-colors hover:bg-slate-100 hover:text-indigo-600"
    >
      <ChevronDownIcon className="size-4 stroke-[2.5px]" />
    </motion.div>
  );
}

export function LineItemAccordionLineItemContent({
  type,
  children,
}: {
  children: React.ReactNode;
  type: string;
}) {
  return (
    <motion.div
      key={type}
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: 'auto', opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      transition={{
        duration: 0.24,
        ease: [0.4, 0, 0.2, 1],
        opacity: { duration: 0.16, delay: 0.04 },
      }}
      className="line-item-accordion-content overflow-hidden"
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.16 }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
}
